/* eslint-disable linebreak-style */
import React, {useState, useEffect} from 'react';
import styled from '@emotion/styled';
import emailjs from 'emailjs-com';
import {addSubscription} from '../../network';


const ComingSoon = () => {
    const [email, setEmail] = useState('');
    const [subscriptionText, setSubscriptionText] = useState('Subscribe to get notified.');
    const [formKey, setFormKey] = useState(new Date());
    
    const saveEmail = (e) => {
        e.preventDefault();
        setEmail(e.target.value);
    };

    const sendSubscriptionEmail = (email) => {
        addSubscription(email).then(res => {
            setSubscriptionText('Thank you for subscribing!');
            setEmail('');
            setTimeout(() => {
                setSubscriptionText('Subscribe to get notified.');
                //setFormKey(new Date());
            }, 5000);
            
        }).catch(err => console.log(err));
        
        emailjs.send('service_j1kx6gd', 'template_8fze1uw', {userEmail: email, reply_to: 'orders@iradjamaica.com'}, 'user_2WLtdj8YcLEeotGGpmp4R')
            .then((response)=> {
                console.log('SUCCESS!', response.status, response.text);
            })
            .catch((error) => {
                console.log('FAILED...', error);
            });
    }
    return (
        <MainWrapper>
            <img src="/coming-soon/top-group.svg" alt="page decor" className="top-group" />
            <img src="/coming-soon/bottom-group.svg" alt="page decor" className="bottom-group" />
            <img src="/coming-soon/bottom-circle.svg" alt="page decor" className="bottom-circle" />
            <ComingSoonWrapper>
                <ComingSoonContainer>
                    <img src="/page-decor/pink-irad-symbol.svg" alt="page decor" className="top-small-circle" />
                    <img src="/page-decor/orange-irad-symbol.svg" alt="page decor" className="orange-circle" />

                    <ImageContainer>
                        <img src="/coming-soon/coming-soon.svg" alt="nurse" className="img" />
                    </ImageContainer>

                    <TextContainer>
                        <p className="title"> Coming Soon </p>
                        <div className="sub-text">
                            The page you are looking for is currently under construction but will be up
                            and running very soon.
                        </div>

                        <SubscribeContainer>
                            <p>{subscriptionText}</p>
                            <div className="email-container">
                                <EmailInput value={email} onChange={(e)=> saveEmail(e)} placeholder="Email" />
                                <NotifyBtn onClick={()=> sendSubscriptionEmail(email)}> Notify Me </NotifyBtn>
                            </div>
                        </SubscribeContainer>
                    </TextContainer>

                </ComingSoonContainer>
            </ComingSoonWrapper>
        </MainWrapper>
    );
};

export default ComingSoon;

const MainWrapper = styled.div`
    width: 100%;
    height: fit-content;
    overflow: hidden;

    .top-group{
        position: absolute;
        z-index: 2;
        left: -5px;
        top: 0px;
    }

    .bottom-group{
        position: absolute;
        z-index: 2;
        right: 0;
        top: 12rem;
    }

    .bottom-circle{
        position: absolute;
        z-index: 2;
        bottom: -16rem;
        right: 20rem;
    }

`;

const ComingSoonWrapper = styled.div`
    margin-top: 2rem;
`;

const ComingSoonContainer = styled.div`
    z-index: -1;
    height: 85vh;
    width: 100%;

    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 2rem;

    .top-small-circle{
        position: absolute;
        z-index: 2;
        left: 35rem;
        top: 20rem;
    }

    .orange-circle{
        position: absolute;
        z-index: 2;
        left: 38.5rem;
        bottom: 2rem;
    }

    @media (max-width: 768px){
        display: flex;
        flex-direction: column;
    }

    @media (max-width: 500px){
       width: fit-content;
    }
    
`;

const ImageContainer = styled.div`
    height: 100%;

    .img{
        height: 100%;
    }

    @media (max-width: 768px){
        display: none;
    }
`;

const TextContainer = styled.div`
     display: flex;
    flex-direction: column;
    justify-content: center;

    height: 100%;
    width: 100%;
    
    .title{
        font-size: 40px;
        font-weight: 500;
        color: var(--company-dark);
    }
    
    .sub-text{
        font-size: 20px;
        font-weight: 400;
        line-height: 32px;
        color: var(--color-gray-700);
        margin-top: 1.5rem;
        
        width: 28rem;

        display: flex;
        flex-direction: column;
    }

    .email-container{
        display: flex;
        flex-direction: row;
        gap: 2.5rem;
    }

    @media (max-width: 768px){
        .email-container{
            display: flex;
            flex-direction: column;
        }
    }

    @media (max-width: 500px){
        margin-left: 1rem;
        width: fit-content;
       .email-container{
           width: fit-content;
       }

       .sub-text{
           width:fit-content;
       }
    }
`;

const SubscribeContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;

    font-size: 20px;
    font-weight: 400;
    color: var(--color-gray-700);

    margin-top: 2rem;
`;

const EmailInput = styled.input`
    display: flex;
    flex-direction: row;
    align-items: center;

    padding: 16px 24px;
    background: #EDF0F2;

    border: 1px solid #D3D9DE;
    box-sizing: border-box;
    border-radius: 8px;
    
    font-size: 20px;

    width: 50%;

    &::placeholder {
        color: var(--color-gray-500);
        font-size: 20px;
        line-height: 20px;
      }

      @media (max-width: 768px){
          width: 100%;
    }
`;

const NotifyBtn = styled.button`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    
    padding: 18px 40px;

    background: #09CCBA;
    box-shadow: 0px 6px 15px rgba(16, 216, 197, 0.34), 0px 2px 6px rgba(16, 216, 197, 0.16);
    border-radius: 44px;

    color: #ffff;
    font-weight: 600;
    font-size: 20px;
    line-height: 20px;

    display: flex;
    align-items: center;
    text-align: center;
`;
